import { render } from "./subject.vue?vue&type=template&id=d46f347c&scoped=true"
import script from "./subject.vue?vue&type=script&lang=js"
export * from "./subject.vue?vue&type=script&lang=js"

import "./subject.vue?vue&type=style&index=0&id=d46f347c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d46f347c"]])

export default __exports__